import { Route, Routes, useLocation } from "react-router-dom";
import Admin from "./Admin/Admin";
import BlogDetailsPage from "./BlogDetailsPage";
import { BlogsPage } from "./BlogsPage";
import ContactMe from "./ContactMe";
import { FromFunctionsRedirection } from "./FromFunctionsRedirection";
import FullScreenLoader from "./FullScreenLoader";
import NotFound from "./NotFound";
import { PortfolioPage } from "./PortfolioPage";
import Resume from "./Resume/Resume";
import WNavBar from "./WNavBar";
import Zahra from "./Zahra/Zahra";
import { AnalyticsService, IAnalyticsService } from "../core/utils/analytics";
import { useEffect } from "react";
import ValentinesDayPage from "./valentines/ValentinesDayPage";

function HomeComponent() {
    const location = useLocation();
    const analyticsService: IAnalyticsService = AnalyticsService.getInstance();
    useEffect(() => {
      analyticsService.logNavigationEvent(location.pathname);
    }, [location, analyticsService]);
    return <div>
        <WNavBar />
        <FullScreenLoader />
        <Routes>
            <Route Component={FromFunctionsRedirection} path="/_/*" />
            <Route Component={BlogsPage} path="/" />
            <Route Component={BlogsPage} path="/blog" />
            <Route Component={BlogDetailsPage} path="/blog/:id" />
            <Route Component={PortfolioPage} path="/portfolio" />
            <Route Component={Resume} path="/resume" />
            <Route Component={Resume} path="/resume/:id" />
            <Route Component={ContactMe} path="/contact-me" />
            <Route Component={Zahra} path="/zahra" />
            <Route Component={ValentinesDayPage} path="/valentines-day" />
            <Route Component={Admin} path="/admin">
                <Route Component={NotFound} path="*" />
            </Route>
            <Route Component={NotFound} path="*" />
        </Routes>
    </div>;
}

export default HomeComponent;